import { DataGrid } from "@mui/x-data-grid";

const Grid = ({ rows, columns, getRowId, onStateChange }) => {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={getRowId}
      onStateChange={onStateChange}  
      pagination
      autoHeight
    />
  );
};

export default Grid;
